export enum AuthenticationType {
	OTP = 'OTP',
	FACE_MATCH_CHECK = 'FACE_MATCH_CHECK',
}
